<div class="admin-signup-container">
  <div class="content">
    <div class="logo-wrapper">
      <img src="assets/logo/logo-full-green.png" alt="Check Plus Logo" class="logo" />
    </div>
    
    <h2 class="form-title">Sign-Up</h2>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="input-group">
        <label class="input-label">Email Address</label>
        <div class="input-wrapper">
          <mat-icon class="prefix-icon">mail_outline</mat-icon>
          <input
            formControlName="email"
            placeholder="Enter your email"
            type="email"
            class="custom-input"
          />
        </div>
      </div>

      <div class="input-group">
        <label class="input-label">Password</label>
        <div class="input-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="Enter your password"
            class="custom-input"
          />
          <mat-icon class="suffix-icon" (click)="showPassword = !showPassword">
            {{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
        <label
          class="error-message"
          *ngIf="
            !form.controls['password'].valid &&
            form.controls['password'].touched
          "
        >
          {{ getPasswordErrorMessage('password') }}
        </label>
      </div>

      <div class="input-group">
        <label class="input-label">Confirm Password</label>
        <div class="input-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword"
            placeholder="Confirm your password"
            class="custom-input"
          />
          <mat-icon class="suffix-icon" (click)="showConfirmPassword = !showConfirmPassword">
            {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
        <label
          class="error-message"
          *ngIf="
            !form.controls['confirmPassword'].valid &&
            form.controls['confirmPassword'].touched
          "
        >
          {{ getPasswordErrorMessage('confirmPassword') }}
        </label>
        <label
          class="error-message"
          *ngIf="
            form.controls['confirmPassword'].valid &&
            form.errors?.['mismatch'] &&
            form.controls['confirmPassword'].touched
          "
        >
          Passwords do not match.
        </label>
      </div>

      <button
        gbui-button
        type="submit"
        class="signup-button"
        [disabled]="form.invalid || isLoading"
        [busy]="isLoading"
        context="primary"
      >
        Sign Up
      </button>
    </form>
    
    <div class="footer-links">
      <div class="already-account">
        Already have an account? <span class="signin-link" routerLink="/authentication/sign-in">Sign in</span>
      </div>
    </div>
  </div>
</div>
